module.exports = __webpack_public_path__ + "static/Student2-065e196b6b603c29da6012e5e0ad8656.jpg";